import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './MessageBox.scss';

interface IOwnProps {
  type: 'error' | 'warning' | 'info' | 'success';
  spacingTop?: boolean;
  spacingBottom?: boolean;
  message: string;
  withBorder?: boolean;
  textAlign?: 'center';
}

const MessageBox: React.SFC<IOwnProps> = ({ message, type, spacingTop, spacingBottom, withBorder, textAlign }) => {
  const messageBoxClassNames = cx({
    [Styles.box]: true,
    [Styles.error]: type === 'error',
    [Styles.warning]: type === 'warning',
    [Styles.info]: type === 'info',
    [Styles.success]: type === 'success',
    [Styles.spacingTop]: spacingTop,
    [Styles.spacingBottom]: spacingBottom,
    [Styles.withBorder]: withBorder,
    [Styles.center]: textAlign && textAlign === 'center',
  });

  return <div className={messageBoxClassNames} dangerouslySetInnerHTML={{ __html: message }} />;
};

export default MessageBox;
